import { render, staticRenderFns } from "./addData.vue?vue&type=template&id=0c601277&scoped=true"
import script from "./addData.vue?vue&type=script&lang=js"
export * from "./addData.vue?vue&type=script&lang=js"
import style0 from "./addData.vue?vue&type=style&index=0&id=0c601277&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c601277",
  null
  
)

export default component.exports